import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { FundingCart, FundingService } from '@bytel/checkout';

import { AppService } from '@services/app.services';
import { MainCartService } from '@services/main-cart.service';
import { MessageService } from '@services/message.service';
import { PaymentService } from '@services/payment.service';

import { ErrorModalComponent } from '@shared/error-modal/error-modal.component';

import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class PaymentResolver {
    private mainCartService: MainCartService = inject(MainCartService);
    private appService: AppService = inject(AppService);
    private messageService: MessageService = inject(MessageService);
    private fundingService: FundingService = inject(FundingService);
    private paymentService: PaymentService = inject(PaymentService);

    resolve(route: ActivatedRouteSnapshot): Observable<{
        openBankingData: { id?: string; url?: string; iban?: string } | undefined;
        fundingCart: FundingCart;
    }> {
        this.appService.formStatusSubject.next({ invalid: false, loading: true });
        return this.mainCartService.refresh().pipe(
            mergeMap(() => (route.queryParams.journeyId ? of(undefined) : this.paymentService.shouldUseOpenBanking())),
            mergeMap((openBankingData) =>
                this.fundingService.getFundingModes(this.mainCartService.cartModel).pipe(
                    map((fundingCart) => ({
                        openBankingData,
                        fundingCart,
                    })),
                ),
            ),
            map((data) => {
                if (!data || !data.fundingCart) {
                    this.messageService.openModal(ErrorModalComponent);
                    throw new Error('Erreur lors de la récupération des modes de financement');
                }
                data.fundingCart.fundingMethods = data.fundingCart.fundingMethods.sort(
                    (a, b) => a.position - b.position,
                );
                return data;
            }),
            catchError((err) => {
                this.messageService.openModal(ErrorModalComponent);
                return throwError(() => new Error(err?.message));
            }),
            finalize(() =>
                this.appService.formStatusSubject.next({
                    ...this.appService.formStatusSubject.getValue(),
                    loading: false,
                }),
            ),
        );
    }
}
